import React,{useEffect} from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Episodes from '../components/Episodes';
import AboutSection from '../components/AboutSection';
import GuestApplication from '../components/GuestApplication';
import Sponsors from '../components/Sponsors';
import Footer from '../components/Footer';

const HomePage=()=> {
  useEffect(()=> {
    // Update page title and meta description
    document.title='Point Makers Podcast | Real Conversations with Darrence & Demetrius Davis';
    const metaDescription=document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Founded in 2024 by brothers Darrence & Demetrius Davis. Real conversations that enlighten, engage, entertain, and educate—recorded in a professional studio setting.'
      );
    }

    // Update Open Graph tags
    const updateMetaTag=(property,content)=> {
      const tag=document.querySelector(`meta[property="${property}"]`) || document.querySelector(`meta[name="${property}"]`);
      if (tag) {
        tag.setAttribute('content',content);
      }
    };

    updateMetaTag('og:title','Point Makers Podcast | Real Conversations with Darrence & Demetrius Davis');
    updateMetaTag('og:description','Founded in 2024 by brothers Darrence & Demetrius Davis. Real conversations that enlighten, engage, entertain, and educate—recorded in a professional studio setting.');
    updateMetaTag('og:url','https://www.pointmakerspod.com/');
    updateMetaTag('twitter:title','Point Makers Podcast | Real Conversations with Darrence & Demetrius Davis');
    updateMetaTag('twitter:description','Founded in 2024 by brothers Darrence & Demetrius Davis. Real conversations that enlighten, engage, entertain, and educate—recorded in a professional studio setting.');
    updateMetaTag('twitter:url','https://www.pointmakerspod.com/');

    // Add structured data
    const structuredData={
      "@context": "https://schema.org",
      "@type": "PodcastSeries",
      "name": "Point Makers Podcast",
      "description": "Real conversations that enlighten, engage, entertain, and educate. Hosted by brothers Darrence and Demetrius Davis.",
      "url": "https://www.pointmakerspod.com/",
      "inLanguage": "en",
      "isAccessibleForFree": true,
      "author": [
        { "@type": "Person", "name": "Darrence Davis" },
        { "@type": "Person", "name": "Demetrius Davis" }
      ],
      "producer": { "@type": "Organization", "name": "Point Makers Podcast" },
      "sameAs": [
        "https://www.youtube.com/@pointmakerspodcast?si=khoIm_WB-cYQAAql", 
        "https://www.instagram.com/pointmakerspodcast/", 
        "https://open.spotify.com/show/1wPc9jHtjXOIjAcKoB9vqh?si=0b631c92d07740d7&nd=1&dlsi=1ab69a7e63ea4987"
      ],
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.pointmakerspod.com/"
          }
        ]
      }
    };

    let structuredScript=document.querySelector('script[data-structured="homepage"]');
    if (!structuredScript) {
      structuredScript=document.createElement('script');
      structuredScript.type='application/ld+json';
      structuredScript.setAttribute('data-structured','homepage');
      document.head.appendChild(structuredScript);
    }
    structuredScript.textContent=JSON.stringify(structuredData);

    // Lazy load images
    const images=document.querySelectorAll('img[data-src]');
    const imageObserver=new IntersectionObserver((entries,observer)=> {
      entries.forEach(entry=> {
        if (entry.isIntersecting) {
          const img=entry.target;
          img.src=img.dataset.src;
          img.classList.remove('lazy');
          imageObserver.unobserve(img);
        }
      });
    });

    images.forEach(img=> imageObserver.observe(img));

    return ()=> {
      if (structuredScript && structuredScript.parentNode) {
        structuredScript.parentNode.removeChild(structuredScript);
      }
    };
  }, []);

  return (
    <div className="homepage">
      <Header />
      <main>
        <Hero />
        <div className="section-divider" />
        <Episodes />
        <div className="section-divider" />
        <AboutSection />
        <div className="section-divider" />
        <GuestApplication />
        <div className="section-divider" />
        <Sponsors />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;